import { useRef } from 'react';
import { Box } from '@mui/material';
import { DatePickerPopover } from '../../components/popover';
import { DatePickerProvider } from '../../context';
import { useDatePickerStore } from '../../hooks/use-store';
import { DatePickerProps } from '../../types';
import { Calendar } from '../../components/calendar';
import { Trigger } from './components/trigger';
import { Field, FieldLabel } from '@/components/ui/field';
import { TimeSelect } from '../../components/time-select';
import { DateInput } from '../../components/date-input';

type Props = Omit<DatePickerProps, 'children'>;

// Originally implemented to meet UI and logic requirements for task TB-5604
function DefaultDatePickerContent() {
  const anchorElRef = useRef<HTMLButtonElement>(null);
  const { toggleOpen } = useDatePickerStore((t) => t.actions);
  const isOpen = useDatePickerStore((t) => t.open);

  return (
    <>
      <Trigger anchorElRef={anchorElRef} />

      <DatePickerPopover
        open={isOpen}
        anchorEl={anchorElRef.current}
        onClose={() => toggleOpen(false)}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            columnGap: '10px',
            padding: '16px 18px',
            width: '100%',
          }}
        >
          <Field>
            <FieldLabel>Start Date</FieldLabel>

            <DateInput />
          </Field>

          <Field>
            <FieldLabel>Start Time</FieldLabel>

            <TimeSelect />
          </Field>
        </Box>

        <Calendar sx={{ padding: '20px 18px' }} />
      </DatePickerPopover>
    </>
  );
}

export function DefaultDatePicker(props: Props) {
  return (
    <DatePickerProvider {...props}>
      <DefaultDatePickerContent />
    </DatePickerProvider>
  );
}
